import { styled, Typography } from '@mui/material';

export const GridLayout = styled('div')(({ theme }) => ({
	display: 'grid',
	gap: '0 8px',

	gridTemplateColumns: 'max-content 24px 1fr',
	gridAutoRows: 'max-content',

	'& .startTime': {
		marginBottom: 16,
	},
	'& .address': {
		minWidth: 0,
	},

	'& svg': {
		display: 'block',
		flexShrink: 0,
	},

	'& .withPath': {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		justifyContent: 'space-between',
	},

	'& .pathWrapper': {
		flex: '1 0 auto',
		minHeight: '32px',
		margin: '6px 0',
	},
	'& .path': {
		boxSizing: 'border-box',
		height: '100%',
		borderLeft: `2px dashed ${theme.palette.neutral[60]}`,
	},
}));

export const StationName = styled(Typography)(() => ({
	overflow: 'hidden',
	textOverflow: 'ellipsis',
}));
